<template>
    <div>
        <CCol sm="12">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;">
               
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <CCard class="border-radius-16px p-4 mb-5">
                        <div class="text-center"> <div class="text-left">
                                <h4 class="custom-36px-700 font-color-171717 text-left mt-2">Register Account</h4>
                                <p class="custom-16px-400 text-left">Let’s create your account</p>
                            </div>
    
                        </div>
    
                        <div v-if="Error" class="ml-4 mr-4 mt-4">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                            </CAlert>
                        </div>
                        <div class="mt-3">
                            <strong class="text-left">Name</strong>
                            <CInput type="text" class="" v-model="name" />
                            <strong class="text-left">Phone</strong>
                            <CInput type="text" class="" v-model="phone" />
                            <strong class="text-left">Email</strong>
                            <CInput type="text" class="" v-model="userEmail" />
                            <strong class="text-left">Password</strong>
                            <CInput type="password" class="" v-model="userPassword" @input="password_check"/>
                            <strong class="text-left">User Type</strong>
                            <v-select v-model="selectedRole" :options="roleOptions" label="Name"></v-select>
                            <br />
                            <input type="radio" class="mr-2" />By creating your account, you agree to our <strong> Terms and Conditions</strong> & <strong>Privacy Policy</strong>
    
    
                        </div>

                        <p class="frmValidation mt-3" :class="{'frmValidation--passed' : userPassword.length > 7}">
                                            <img v-if="userPassword.length > 7" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" alt="Unchecked" class="frmIcon" style="width:20px" /> A minimum of 8 character
    
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }">
                                            <img v-if="has_uppercase" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" />  At least one uppercase character
                </p>

                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_lowercase }">
                                            <img v-if="has_lowercase" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one lowercase character
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_number }">
                                            <img v-if="has_number" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one numeric character
                                        </p>
                                        <p class="frmValidation" :class="{'frmValidation--passed' : has_special }">
                                            <img v-if="has_special" src="../assets/img/checked.png" style="width:20px" />
                                            <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one symbol character
                                        </p>
                        <div class="text-center mt-3 mb-4">
                            <CButton class="bg-0B63F6 p-2 text-center text-white pr-5 pl-5 border-radius-half" v-if="userPassword.length > 7 && has_uppercase && has_lowercase && has_number && has_special" @click="registerAccount" block>Create</CButton>
                            <CButton class="bg-636f83 p-2 text-center text-white pr-5 pl-5 border-radius-half" v-else block style="cursor:not-allowed">Create</CButton>
                        </div>
                        <p>Already have an account? <a href="">Login</a></p>
    
                    </CCard>

                </CCard>
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            name: "",
            phone: "",
            userPassword: "",
            userEmail: "",
            selectedRole: "",

            Error: false,

            has_number: false,
            has_lowercase: false,
            has_uppercase: false,
            has_special: false,
           

            roleOptions: []

        }





    },
    async mounted() {
        //     try {
        //         const isAuth = await this.UserAuth();
        //         if (isAuth) {

        //         } else {
        //             this.GoToPage();
        //             this.$nextTick(() => {
        //   this.setCalendarView();
        // });
        //         }
        //     } catch (error) {
        //         this.GoToPage();
        //         console.error("Error during authentication:", error);
        //         // Handle the error here
        //     }
        this.getUserType();

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        registerAccount() {
            this.lblProgress = "Processing";

            const formData = new FormData();

            if (this.userEmail === "" || this.userPassword === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.userEmail);
                formData.append("phone", this.phone);
                formData.append("userType", this.selectedRole.Name);
                formData.append("password", this.userPassword);

                this.$API
                    .post(this.$Register, formData)
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {
                                if (response.data.status !== 400) {

                                    if (
                                        this.$route.query.targetUrl != "" &&
                                        (this.$route.query.targetUrl != null) &
                                        (this.$route.query.targetUrl != undefined)
                                    ) {
                                        this.$router.push(this.$route.query.targetUrl);
                                    } else {
                                        //this.isLanguagePopupVisible1 = true;
                                        this.$router.push("Login");
                                    }
                                } else {
                                    this.Loading = false;
                                    this.Message = response.data.message;
                                    this.Error = true;
                                    this.MessageError = true;
                                }

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                                this.MessageError = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                            this.MessageError = true;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                        this.MessageError = true;
                    });
            }
        },

        password_check() {
            this.has_number = /\d/.test(this.userPassword);
            this.has_lowercase = /[a-z]/.test(this.userPassword);
            this.has_uppercase = /[A-Z]/.test(this.userPassword);
            this.has_special = /[!@#$%^&*(),.?":{}|<>]/.test(this.userPassword);

            // Debugging logs
            console.log('Password:', this.userPassword);
            console.log('Has number:', this.has_number);
            console.log('Has lowercase:', this.has_lowercase);
            console.log('Has uppercase:', this.has_uppercase);
            console.log('Has special:', this.has_special);
        },
        async getUserType() {
              try {
                  const response = await this.$API.get(this.$GetUserType);
                  if (response.status === 200) {
                      this.roleOptions = response.data;
                  } else {
                      // Handle non-200 status code
                      console.error("Failed to fetch user information:", response);
                  }
              } catch (error) {
                  console.error("Error fetching user information:", error);
                  // Handle the error here
              }
          },



    }

};
</script>